import { create } from "zustand";

/**
 * What this browser has LEARNED about the guest trash per event.
 *
 * The backend tells the FE whether the trash is on only inside the delete
 * impact (`GuestDeleteImpactDTO.trash.enabled`) and by answering a delete in
 * TRASH mode — there is no feature endpoint. The sidebar's Papierkorb entry is
 * visible when the trash is known to be on OR it holds rows (`/trash/count`),
 * so both learners write here and the sidebar reads it. Session-scoped on
 * purpose: nothing persisted, nothing to roll back.
 */
type GuestTrashFeatureState = {
  enabledByEvent: Record<string, boolean>;
  learnEnabled: (eventId: string, enabled: boolean) => void;
};

export const useGuestTrashFeature = create<GuestTrashFeatureState>((set) => ({
  enabledByEvent: {},
  learnEnabled: (eventId, enabled) =>
    set((s) =>
      s.enabledByEvent[eventId] === enabled
        ? s
        : { enabledByEvent: { ...s.enabledByEvent, [eventId]: enabled } },
    ),
}));

/** Imperative twin for non-React callers (handlers). */
export function learnGuestTrashEnabled(eventId: string, enabled: boolean): void {
  useGuestTrashFeature.getState().learnEnabled(eventId, enabled);
}
